<template>
    <div class="body-inner">
        <header-component></header-component>
        <!-- DETALLE DE PRODUCTO -->
        <section id="product-page" class="product-page p-b-0">
            <div class="container">
                <div class="product">
                    <div class="row m-b-40">
                        <div class="col-lg-2">
                            <div class="product-image">
                                
                            </div>
                        </div>
                        <div class="col-lg-10">
                            <div class="product-description">
                                <div class="product-category"></div>
                                <div class="product-title">
                                    <h3>
                                        <a href="#">Tus compras realizadas</a>
                                    </h3>
                                </div>
                                <div class="product-price"></div>
                                <p>Aquí podras consultar las compras que has realizado con nosotros</p>
                                <div class="seperator m-t-20 m-b-10"></div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="table table-sm table-striped table-responsive">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th class="cart-product-thumbnail"># Orden</th>
                                                        <th class="cart-product-thumbnail">Producto</th>
                                                        <th class="cart-product-thumbnail">Versiones</th>
                                                        <th class="cart-product-thumbnail">Cantidad</th>
                                                        <th class="cart-product-price">Total</th>
                                                        <th class="cart-product-thumbnail">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="compra in compras" :key="compra.id">
                                                        <td class="cart-product-thumbnail">
                                                            {{ compra.clave }}
                                                        </td>
                                                        <td class="cart-product-thumbnail">
                                                        </td>
                                                        <td class="cart-product-thumbnail">
                                                        </td>
                                                        <td class="cart-product-thumbnail">
                                                        </td>
                                                        <td class="cart-product-thumbnail">
                                                            {{ compra.total }}
                                                        </td>
                                                        <td class="cart-product-thumbnail">
                                                            {{ compra.status }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Footer -->
        <footer id="footer">
            <div class="copyright-content">
                <div class="container">
                    <div class="copyright-text text-center">&copy; 2023 <a href="https://etciberoamerica.com/" target="_blank" rel="noopener">Global Certification Academy.</a> </div>
                </div>
            </div>
        </footer>
        <!-- end: Footer -->
    </div>
</template>

<script>
/* eslint-disable */
import HeaderComponent from '../../components/Store/HeaderComponent'
export default {
    name: 'DetalleProducto',
    components: {
    HeaderComponent
    },
    data() {
        return {
            compras: []
        }
    },

    methods: {
        
    },

    async mounted() {
        const script = document.createElement('script')
        script.src = 'js/functions.js'
        document.body.appendChild(script)

        setTimeout(async () => {
            await this.getCompras()
        }, 1000)
    },
}
</script>
<style lang="css" scoped src="../../assets/css/style.css"></style>
<style lang="css" scoped src="../../assets/css/pluginsStore.css"></style>